/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React from 'react';
import SlotEditorLocalFilters from '../SlotEditorLocalFilters';
import SlotEditorA11YHandler from '../SlotEditorA11YHandler';
import LocalFilterExtensionAPI from './LocalFilterExtensionAPI';
const APIFactory = require('gemini/lib/@waca/dashboard-common/dist/core/APIFactory');

class LocalFilterExtension {
	constructor({ features }) {
		this._features = features;
		this._dashboard = features.API;
		this._slotEditorDOM = features.SlotEditorDOM;
		this.a11YHandler = new SlotEditorA11YHandler();

		this._api = APIFactory.createAPI(this, [LocalFilterExtensionAPI]);
		this._slotEditorDOM.addExtension({
			index: 1,
			render: this.render.bind(this)
		});
	}

	getAPI() {
		return this._api;
	}

	render() {
		const dndManager = this._dashboard.getDashboardSvc('.DndManager');
		const slotEditorModel = this._features['SlotEditorState'].getModel();
		const localFiltersInfo = slotEditorModel.getLocalFilters();
		return (
			<SlotEditorLocalFilters
				dndManager={dndManager}
				filterItemActionHandler={slotEditorModel.getFilterActionHandler()}
				localFiltersInfo={localFiltersInfo}
				a11Y={this.a11YHandler}
				dashboardApi={this._dashboard}
			/>
		);
	}
}

module.exports = LocalFilterExtension;



// WEBPACK FOOTER //
// ./src/js/dashboard/LocalFilterExtension.js